<template>
  <div class="bilingual-news">
    <BackToTop />
    <div class="container">
      <BannerCarousel
        :banners="banners"
        :topNewsList="topNewsList"
        :showLanguageSwitch="Number($route.query.categoryId) === 1"
        @language-change="handleLanguageChange"
      />
      <!-- <ScrollBanner :heZuoImgList="heZuoImgList" /> -->
      <div class="main">
        <div class="main_left">
          <div class="main_item" v-for="item in newsList" :key="item.id">
            <div class="main_item_img">
              <img :src="item.cover_img" alt="" />
            </div>
            <div
              class="main_item_box"
              @click="goToDetail(item.id, isChinese ? 'zh' : 'en')"
              style="cursor: pointer"
            >
              <h1 class="title">
                {{ isChinese ? item.title : (item.title_en || '-') }}
              </h1>
              <h1 class="content">
                {{ isChinese ? item.summary : (item.summary_en || '-') }}
              </h1>
              <div class="box_bottom">
                <div class="theme">
                  <h1>{{ isChinese ? "来自主题:" : "From Theme:" }}</h1>
                  <h1 class="theme-text">
                    {{ isChinese ? item.source : (item.source_en || '-') }}
                  </h1>
                  <h1>|</h1>
                  <h1>{{ (isChinese ? item.author : (item.author_en || '-')) || '-' }}</h1>
                </div>
                <div class="time">
                  <img src="../assets/time.png" alt="" />
                  <span>{{ formatTime(item.create_time) }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="more" @click="loadMore" v-if="!noMore">点击加载更多</div>
          <div class="more" v-else>没有更多了</div>
        </div>
        <div class="main_right">
          <div
            class="plate_right_item"
            v-for="item in classSonList"
            :key="item.id"
          >
            <div class="plate_right_item_title">
              <span>{{ item.name }}</span>
            </div>
            <div class="plate_right_item_content">
              <div
                class="plate_right_item_content_item"
                @click="openUrl(item.url)"
              >
                <img :src="item.img" alt="" />
              </div>
            </div>
          </div>
          <div
            class="plate_right"
            style="display: flex; gap: 10px; flex-direction: column"
          >
            <div class="plate_right_item">
              <div class="plate_right_item_title">
                <span>品牌官说</span>
              </div>
              <div class="plate_right_item_content" v-if="guanShuoList[0]">
                <div class="plate_right_item_content_item">
                  <img :src="getFullUrl(guanShuoList[0].cover_img)" alt="" />
                </div>
              </div>
            </div>
            <div class="main_plate_news">
              <span
                v-for="item in guanShuoList"
                :key="item.id"
                :class="item.is_bold === 1 ? 'news2' : 'news1'"
                @click="goToDetail(item.id, isChinese ? 'zh' : 'en')"
              >
                {{ item.title }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerCarousel from "../components/BannerCarousel.vue";
import BackToTop from "../components/BackToTop.vue";
import { getNewsList } from "@/api/index";

import { imgBaseURL } from "@/api/index";
export default {
  name: "BilingualNews",
  components: {
    BannerCarousel,
    BackToTop,
  },
  data() {
    return {
      banners: [],
      topNewsList: [],
      heZuoImgList: [],
      classSonList: [],
      newsList: [],
      guanShuoList: [],
      isChinese: true,
      currentPage: 1,
      loadingMore: false,
      noMore: false,
    };
  },
  watch: {
    "$route.query.categoryId"() {
      this.currentPage = 1;
      this.newsList = [];
      this.noMore = false;
      this.fetchNewsList();
    },
  },
  mounted() {
    this.fetchNewsList();
  },
  methods: {
    async fetchNewsList(loadMore = false) {
      const categoryId = this.$route.query.categoryId;
      if (!categoryId) return;
      const page = loadMore ? this.currentPage + 1 : 1;
      try {
        const res = await getNewsList(Number(categoryId), page, 20);
        if (res.code === 1 && res.data) {
          const data = res.data;
          // 处理轮播图数据
          this.banners = (data.carousel_list || []).map((item) => ({
            id: item.id,
            img: item.cover_img
              ? item.cover_img.startsWith("http")
                ? item.cover_img
                : imgBaseURL + item.cover_img
              : "",
            title: item.title || "",
            title_en: item.title_en || "",
          }));
          // 处理右侧新闻数据
          this.topNewsList = data.top_news_list || [];
          // 处理滚动轮播图数据
          this.heZuoImgList = (data.he_zuo_img_list || []).map((item) => {
            const img = item.img
              ? item.img.startsWith("http")
                ? item.img
                : imgBaseURL + item.img
              : "";
            return { ...item, img };
          });
          // 处理右侧子分类数据
          this.classSonList = (data.class_son_list || []).map((item) => ({
            ...item,
            img: item.img
              ? item.img.startsWith("http")
                ? item.img
                : imgBaseURL + item.img
              : "",
          }));
          // 处理“品牌官说”列表
          this.guanShuoList = data.guan_shuo || [];
          // 处理新闻列表数据
          const newList = (data.news_list || []).map((item) => ({
            ...item,
            cover_img: item.cover_img
              ? item.cover_img.startsWith("http")
                ? item.cover_img
                : imgBaseURL + item.cover_img
              : "",
          }));
          if (loadMore) {
            this.newsList = [...this.newsList, ...newList];
            this.currentPage++;
          } else {
            this.newsList = newList;
            this.currentPage = 1;
          }
          // 判断是否还有更多数据
          this.noMore = newList.length < 20;
        }
      } catch (error) {
        console.error("获取新闻列表失败:", error);
      }
    },
    loadMore() {
      if (this.loadingMore || this.noMore) return;
      this.loadingMore = true;
      this.fetchNewsList(true).finally(() => {
        this.loadingMore = false;
      });
    },
    handleLanguageChange(lang) {
      this.isChinese = lang === "zh";
    },
    formatTime(createTime) {
      const ts = Number(createTime);
      if (!ts) return "";
      const now = Date.now();
      const timeMs = ts < 1e12 ? ts * 1000 : ts; // 兼容秒/毫秒
      const diffMs = Math.max(0, now - timeMs);
      const diffSec = Math.floor(diffMs / 1000);
      if (diffSec < 60) return "刚刚";
      const diffMin = Math.floor(diffSec / 60);
      if (diffMin < 60) return `${diffMin}分钟前`;
      const diffHour = Math.floor(diffMin / 60);
      if (diffHour < 24) return `${diffHour}小时前`;
      const d = new Date(timeMs);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },
    goToDetail(id, lang) {
      window.open(this.$router.resolve({
        name: "NewsDetail",
        params: { id: id },
        query: { lang: lang || 'zh' }
      }).href, '_blank');
    },
    openUrl(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    getFullUrl(path) {
      if (!path) return "";
      return path.startsWith("http") ? path : imgBaseURL + path;
    },
  },
};
</script>

<style scoped lang="scss">
.bilingual-news {
  // min-height: 100vh;
  // padding: 40px 0;

  // 重置 h1 的默认样式
  h1 {
    margin: 0;
    padding: 0;
    font-weight: normal;
    font-size: inherit;
  }

  .container {
    max-width: 76rem;
    margin: 0 auto;
  }
  .main_plate_news {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 446px;
    span {
      width: 100%;
      display: -webkit-box; /* 1. 将对象作为弹性伸缩盒子模型显示 */
      -webkit-line-clamp: 1; /* 2. 限制块元素显示的行数（这里是1行） */
      line-clamp: 1;
      -webkit-box-orient: vertical; /* 3. 设置或检索伸缩盒对象的子元素的排列方式 */
      overflow: hidden; /* 4. 隐藏超出部分 */
      // text-overflow: ellipsis; /* 5. 用省略号代替隐藏部分（配合hidden使用） */
    }
    .news1 {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #424242;
      cursor: pointer;
    }
    .news2 {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #424242;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .main {
    display: flex;
    justify-content: space-between;
    padding-bottom: 120px;
    box-sizing: border-box;
    .main_left {
      width: 70%;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .main_item {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e9e9e9;
        padding: 10px 0;
        box-sizing: border-box;
        .main_item_img {
          width: 220px;
          height: 109px;
          margin-right: 30px;
          display: flex;
          align-items: center;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease, filter 0.3s ease;
            &:hover {
              transform: scale(1.05);
              filter: brightness(1.1);
            }
          }
        }
        .main_item_box {
          display: flex;
          flex: 1;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
          &:hover {
            .title {
              color: #dc0d1d !important;
            }
            .theme .theme-text {
              color: #dc0d1d !important;
            }
          }
          .title {
            font-family: MicrosoftYaHeiSemilight;
            font-size: 19px;
            color: #333333;
            text-align: left;
            display: -webkit-box; /* 1. 将对象作为弹性伸缩盒子模型显示 */
            -webkit-line-clamp: 1; /* 2. 限制块元素显示的行数（这里是1行） */
            line-clamp: 1;
            -webkit-box-orient: vertical; /* 3. 设置或检索伸缩盒对象的子元素的排列方式 */
            overflow: hidden; /* 4. 隐藏超出部分 */
            text-overflow: ellipsis; /* 5. 用省略号代替隐藏部分（配合hidden使用） */
            margin-bottom: 10px;
          }
          .content {
            font-family: MicrosoftYaHei;
            font-size: 15px;
            color: #a7a7a7;
            text-align: justifyLeft;
            font-weight: 400;
            display: -webkit-box; /* 1. 将对象作为弹性伸缩盒子模型显示 */
            -webkit-line-clamp: 2; /* 2. 限制块元素显示的行数（这里是1行） */
            line-clamp: 1;
            -webkit-box-orient: vertical; /* 3. 设置或检索伸缩盒对象的子元素的排列方式 */
            overflow: hidden; /* 4. 隐藏超出部分 */
            text-overflow: ellipsis; /* 5. 用省略号代替隐藏部分（配合hidden使用） */
          }
          .box_bottom {
            display: flex;
            justify-content: space-between;
            margin-top: auto;
            .theme {
              display: flex;
              align-items: center;
              gap: 10px;
              h1 {
                font-family: MicrosoftYaHeiSemilight;
                font-size: 13px;
                color: #777777;
                text-align: left;
                transition: color 0.3s;
              }
            }
            .time {
              display: flex;
              align-items: center;
              img {
                width: 15px;
                height: 15px;
                margin-right: 8px;
              }
              span {
                font-family: MicrosoftYaHeiLight;
                font-size: 13px;
                color: #777777;
              }
            }
          }
        }
      }
      .more {
        width: 230px;
        height: 45px;
        border: 1px solid red;
        font-family: MicrosoftYaHeiSemilight;
        font-size: 16px;
        color: red;
        text-align: center;
        line-height: 45px;
        margin: 50px auto 0;
        cursor: pointer;
      }
    }
    .main_right {
      width: 27%;
      display: flex;
      flex-direction: column;
      margin-top: 30px;
      gap: 30px;
      .plate_right_item {
        display: flex;
        flex-direction: column;
        .plate_right_item_title {
          margin-bottom: 20px;
          span {
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 500;
            font-size: 20px;
            color: #000000;
          }
        }
        .plate_right_item_content {
          display: flex;
          gap: 10px;
          .plate_right_item_content_item {
            cursor: pointer;
            width: 100%;
            overflow: hidden;
            img {
              width: 100%;
              height: 169px;
              object-fit: cover;
              transition: transform 0.3s ease, filter 0.3s ease;
              &:hover {
                transform: scale(1.05);
                filter: brightness(1.1);
              }
            }
          }
        }
      }
    }
  }
}

/* 平板：宽度 <= 1200px 时，两栏改为上下布局，增加左右内边距 */
@media (max-width: 1200px) {
  .container {
    max-width: 100% !important;
    padding: 0 16px;
    box-sizing: border-box;
  }

  .main {
    flex-direction: column;
    gap: 24px;
    padding-bottom: 80px;

    .main_left,
    .main_right {
      width: 100% !important;
    }

    .main_right {
      margin-top: 0;
      gap: 20px;
    }
  }
}

/* 移动端：宽度 <= 768px 时，列表卡片化，图片自适应，文字更紧凑 */
@media (max-width: 768px) {
  .container {
    padding: 0 12px;
  }

  .main {
    padding-bottom: 56px;
  }

  .main_left {
    gap: 0;

    .main_item {
      flex-direction: column;
      align-items: stretch;
      padding: 14px 0;
      gap: 10px;

      .main_item_img {
        width: 100%;
        height: auto;
        margin-right: 0;
        overflow: hidden;

        img {
          width: 100%;
          height: auto;
          border-radius: 6px;
          display: block;
          transition: transform 0.3s ease, filter 0.3s ease;
          &:hover {
            transform: scale(1.05);
            filter: brightness(1.1);
          }
        }
      }

      .main_item_box {
        &:hover {
          .title {
            color: #dc0d1d;
          }
          .theme h1 {
            color: #dc0d1d;
          }
        }
        .title {
          font-size: 16px;
          margin-bottom: 8px;
          -webkit-line-clamp: 2;
          line-clamp: 2;
        }

        .content {
          font-size: 14px;
          -webkit-line-clamp: 2;
          line-clamp: 2;
        }

        .box_bottom {
          gap: 10px;
          flex-wrap: wrap;
          margin-top: 5px !important;
          .theme {
            gap: 6px;

            h1 {
              font-size: 12px;
            }
          }

          .time span {
            font-size: 12px;
          }
        }
      }
    }

    .more {
      width: 100%;
      max-width: 320px;
      height: 42px;
      line-height: 42px;
      margin: 24px auto 0;
      font-size: 15px;
    }
  }

  .main_right {
    margin-top: 0;
    gap: 16px;

    .plate_right_item {
      .plate_right_item_title span {
        font-size: 18px;
      }
    }

    .main_plate_news {
      max-width: 100%;
      gap: 6px;

      .news1,
      .news2 {
        font-size: 14px;
      }
    }
  }
}
</style>
